// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"17b64b9a","113":"0a2a71c7","391":"39830723","555":"0ff3cc41","660":"c3402e38"}[chunkId] + ".chunk.js";
};